import { VerityAssessment } from "@verity/api-client/types";
import { QuizWithProctoringOptions } from "../../assessments-page-helper";
import { useContext, useMemo } from "react";
import { PortalControllerContext } from "../../../../context";
import { buildAssessmentDetailsInitialValues } from "./useAssessmentDetails";
import { CoreFileItem } from "@verity/components/core";
import { buildAddInstructionsInitialValues } from "./useAddInstructions";
import { buildQuestionDeliveryInitialValues } from "./useQuestionDelivery";
import { buildInitialQuestions } from "./useQuizQuestions";
import { QuizDraftQuestion } from "../verityAssessmentHelper";

export default function useInitialValues(
	verityAssessment?: VerityAssessment,
	assessment?: QuizWithProctoringOptions,
	instructorFiles: CoreFileItem[] = [],
) {
	const { portalContext } = useContext(PortalControllerContext);
	const { lms } = portalContext;

	const quizQuestionsInitialValues = useMemo(() => {
		return buildInitialQuestions(verityAssessment);
	}, [verityAssessment]);

	const assessmentDetailsInitialValues = useMemo(() => {
		return buildAssessmentDetailsInitialValues(verityAssessment, assessment, lms, quizQuestionsInitialValues);
	}, [assessment, lms, verityAssessment, quizQuestionsInitialValues]);

	const addInstructionsInitialValues = useMemo(() => {
		return buildAddInstructionsInitialValues(instructorFiles, quizQuestionsInitialValues);
	}, [instructorFiles, quizQuestionsInitialValues]);

	const questionDeliveryInitialValues = useMemo(() => {
		return buildQuestionDeliveryInitialValues(verityAssessment);
	}, [verityAssessment]);

	const quizQuestions = useMemo((): QuizDraftQuestion[] => {
		return (quizQuestionsInitialValues ?? []).filter((q) => q.questionType !== "FileUpload") as QuizDraftQuestion[];
	}, [quizQuestionsInitialValues]);

	return {
		assessmentDetails: assessmentDetailsInitialValues,
		addInstructions: addInstructionsInitialValues,
		questionDelivery: questionDeliveryInitialValues,
		quizQuestions,
	};
}
